export default __webpack_public_path__ + "static/media/ic_filter_list.ef5c2d02.svg";